import React from "react"
import PropTypes from "prop-types"

import TopicElement from '../exchanges_sections/TopicElement'

class MeetingTopics extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      topics: [],
      userId: '',
    }
    this.getTopics = this.getTopics.bind(this)
  }

  getTopics() {
    $.ajax({
      url: `../get_meetings_exchanges`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        user_id: this.props.userId
      },
      success: (data) => {
          this.setState({
            topics: JSON.parse(data.data.exchanges)
          })
          return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidUpdate() {
    if(this.state.userId != this.props.userId) {
      this.setState({
        userId: this.props.userId
      }, this.getTopics())
    }
  }

  componentWillMount() {
    this.setState({
      userId: this.props.userId
    }, this.getTopics())
  }

  render() {
    const topicCards = this.state.topics.map((topic) => (
      <TopicElement
        topic={topic}
        key={topic.id}
        index={topic.id}
        meetingId={this.props.isCurrentUser ? this.props.meetingId : undefined}
      />
    ))

    return(
      <div className="lexScheduleTopics">
        {topicCards}
      </div>
    )
  }

}

export default MeetingTopics;
